import React, { useState } from 'react';
import { AbonosPartesScreen } from './screen';
import { PartesAdapter } from '../../../../../infraestructure/persistence/rest/PartesAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import { useUserSettings } from '../../../context/CurrentUserContext';
import { PERFIL_ADMIN } from '../../../../../shared/constanst/constants';

export const AbonosPartesContainer = (props:any)=>{

    const {refresh} = props;
    const {resultError, exceptionError, launchNotification} = useNotifications();
    const api = new PartesAdapter();
    const {currentUser}:any = useUserSettings();

    let [isLoading, setIsLoading] = useState(false);

    const onRealizarAbonoPartes = async(idsPartes:string[])=>{
        setIsLoading(true)
        try {
            const result = await api.AbonarPartes(idsPartes);
            if(result.data && result.data!=="")
                  {
              launchNotification({type:"success",title:"Generar Abono Partes",message:"Se ha realizado un abono de los partes seleccionados."})
              setIsLoading(false)
              refresh()
            }else{resultError();setIsLoading(false)}
              } catch (e) {
                  let exception = ServerErrorMessage(e);
            exceptionError(exception);
            setIsLoading(false)
        }
    }

    const onRealizarAbonoPartesConModificaciones = async(request:any)=>{
        setIsLoading(true)
        try {
            const result = await api.AbonarPartesConConfiguracion(request);
            if(result.data && result.data!=="")
                  {
              launchNotification({type:"success",title:"Generar Abono Partes Con Configuración",message:"Se ha realizado el abono y regeneración de los partes seleccionados."})
              setIsLoading(false)
              refresh()
            }else{resultError();setIsLoading(false)}
              } catch (e) {
                  let exception = ServerErrorMessage(e);
            exceptionError(exception);
            setIsLoading(false)
        }
    }

    return (currentUser&&currentUser.perfil===PERFIL_ADMIN) ? 
    <AbonosPartesScreen {...props} handleAbonar={onRealizarAbonoPartes} handleAbonarConModificaciones={onRealizarAbonoPartesConModificaciones} 
    user={currentUser}/> 
    : null;
}